/*
 * Copyright © 2020-2024 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2024-09-11 09:42:30
 */

import React, { useEffect, useMemo } from 'react'
import { Button } from 'antd'
import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import sensors, { parsePlaceValue } from '../../../utils/sensors'
import { useOnPay } from './hooks'

const VipTip = ({ vipRequired, limitedTimeFree, modalOpen }) => {
  const dispatch = useAppDispatch()
  const groupID = useAppSelector((state) => state.group.groupId)
  const isVip = useAppSelector((state) => state.group.isVip)
  const onPay = useOnPay()

  const visible = useMemo(() => {
    return modalOpen && vipRequired && !limitedTimeFree && !isVip
  }, [modalOpen, vipRequired, limitedTimeFree, isVip])

  useEffect(() => {
    if (visible) {
      sensors.track('web_show_page_openapp_workgroupvip', {
        groupID: groupID,
        place: parsePlaceValue(),
        functionType: 'chooseMember'
      })
    }
  }, [visible])

  if (visible) {
    return (
      <div className="vip-tip">
        开通<strong>团队会员</strong>解锁使用
        <Button
          type="link"
          onClick={() => {
            sensors.track('web_click_button_workgroup_go_vip_trigger', {
              place: parsePlaceValue(),
              functionType: 'chooseMember',
              groupID
            })
            onPay()
          }}
        >
          <strong>[立即开通]</strong>
        </Button>
      </div>
    )
  }
  return null
}

export default VipTip
